// import { AbpHttpInterceptor } from '@abp/abpHttpInterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { InterceptedHttp /*, CatalystHttpConfiguration*/ } from './abp-http.interceptor';
// import { LogService } from '@abp/log/log.service';
// import { Correlator } from './correlator';

// export function httpFactory(configuration: CatalystHttpConfiguration,
//     logger: LogService, correlator: Correlator): AbpHttpInterceptor {
//     return new InterceptedHttp(configuration, logger, correlator);
// }

export const CATALIST_HTTP_PROVIDER = {
    provide: HTTP_INTERCEPTORS,
    // useFactory: httpFactory,
    // deps: [CatalystHttpConfiguration, LogService, Correlator]
    useClass: InterceptedHttp,
    multi: true
};
